import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";
import { DocumentInputContentV1 } from "@demo/types/documentContent";

export const agricultureWeeds: TemplateDefinition = {
  mode: "compose",
  slug: "agriculture-weeds",
  version: 1,
  title: "Agriculture",
  description: "Categorize objects",
  thumbnailUuid: BASE_ASSETS.weeds.uuid,
  assets: [BASE_ASSETS.weeds],
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.weeds.uuid,
              extension: BASE_ASSETS.weeds.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: {
          type: "text",
          value: "Localize all weeds individually.",
        },
      },
    ],
    outputAnnotations: false,
    variables: {},
    temperature: 0,
    annotationFormat: "box",
    enableThinking: false,
  } satisfies DocumentInputContentV1,
};
